export default __webpack_public_path__ + "1b81235bf64046c7d5039b85c642e590.png";